export const initialState = {
  shopOrders: [],
  needsTotalsFetch: true,
  totals: {},
  notifications: []
}

// We currently only maintain an array of shopOrders because the grid always expects an array.
export default function(state=initialState, action) {
  const { type } = action
  const payload = action.payload || {}
  const data = payload.data || {}

  switch(type) {
    case 'SHOP_ORDERS_LOAD_SUCCEEDED':
      return {
        ...state,
        ...payload.data,
        needsTotalsFetch: true
      }
    case 'SHOP_ORDER_LOAD_SUCCEEDED':
      return {
        ...state,
        orderDetails: { ...state.orderDetails, [data.order.id]: data.order },
        needsTotalsFetch: true
      }
    case 'SHOP_ORDERS_TOTALS_LOAD_SUCCEEDED':
      return {
        ...state,
        totals: payload.data,
        needsTotalsFetch: false
      }
    case 'SHOP_ORDERS_FILTER_SUCCEEDED':
      return {
        ...state,
        ...payload.data,
        needsTotalsFetch: true
      }
    case 'SHOP_ORDERS_UPDATE_SUCCEEDED':
      const updatedOrders = state.orders.map(order => {
        return (order.id === data.id) ? data : order
      })
      return {
        ...state,
        orders: updatedOrders,
        orderDetails: { ...state.orderDetails, [data.id]: data },
        needsTotalsFetch: true
      }
    case 'SHOP_ORDER_NOTIFICATIONS_UPDATE':
      return {
        ...state,
        notifications: state.notifications.concat(payload.data)
      }
    case 'SHOP_ORDER_NOTIFICATIONS_DELETE':
      return {
        ...state,
        notifications: state.notifications.filter(n => n.notification_id !== payload.data.id)
      }
    case 'SHOP_ORDER_NOTIFICATIONS_DELETE_ALL':
      return {
        ...state,
        notifications: []
      }
    case 'SHOP_ORDER_CLEAR':
      return {
        ...state,
        orders: []
      }
    default:
      return state
  }
}
